export default "__VITE_ASSET__BKOHwnw$__"